@use "../../style/variables" as *;
@use "../../style/mixins" as *;

.header {
  width: 100%;
  height: 10.5rem;
  padding: 2rem 0 0;
  font-size: 1rem;

  @include mobile {
    height: 2.75rem;
    background: white;
    padding: 0;
    z-index: 1;
    position: fixed;
    top: 0;
    border-bottom: 1px solid $grey-light;
  }

  .logo {
    margin-left: auto;
    margin-right: auto;
    width: auto;
    display: block;

    @include mobile {
      display: none;
    }
  }

  .headline {
    color: $grey-text;
    margin: 0.6875rem auto;
  }
}

.mobile-only {
  display: none;

  @include mobile {
    display: flex;
    flex-direction: row;
    justify-content: center;
    padding-top: 3.7rem;
    background-color: $white;
  }
}

.icon {
  position: absolute;
  right: 0;
  align-self: center;
  margin-right: 1.3125rem;
}

.icon svg {
  width: 1.5rem;
  height: 1.5rem;
}

.solid {
  fill: $grey-text;
  stroke: none
}


